import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Label, Input } from "rbx";

const TariffRateForm = ({ inputs, onChange }) => (
  <React.Fragment>
    <Field>
      <Control>
        <Label>Max. Miles</Label>
        <Input
          autocomplete="new"
          name="MaxMiles"
          type="number"
          value={inputs.MaxMiles}
          onChange={onChange}
        />
      </Control>
    </Field>
    <Field>
      <Control>
        <Label>Rate</Label>
        <Input
          autocomplete="new"
          name="Rate"
          step="0.01"
          type="number"
          value={inputs.Rate}
          onChange={onChange}
        />
      </Control>
    </Field>
  </React.Fragment>
);

TariffRateForm.propTypes = {
  inputs: PropTypes.object,
  onChange: PropTypes.func
};
TariffRateForm.defaultProps = {
  inputs: {}
};
export default TariffRateForm;
